import React from 'react';

import { QuestionSingleChoiceWithText, QuestionTypeV2 } from '../../../redux/types';
import ChoiceTextQuestionEditor from '../ChoiceTextQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionSingleChoiceWithText;
  addQuestion?: (dq: Omit<QuestionSingleChoiceWithText, 'id'>) => void
  updateQuestion?: (dq: QuestionSingleChoiceWithText) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
  enableTNA?: boolean;
}

const SingleChoiceWithTextQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
  enableTNA,
}: Props) => (
  <ChoiceTextQuestionEditor<QuestionSingleChoiceWithText>
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    type={QuestionTypeV2.SingleChoiceWithText}
    disableHideAggregation={disableHideAggregation}
    enableTNA={enableTNA}
  />
);

export default SingleChoiceWithTextQuestionEditor;
